import { useCallback } from 'react'
import { useFetchRefactored } from 'civic-champs-shared/api/hooks'

export const useGetCognitoUser = () => {
  const [request, status] = useFetchRefactored()

  const getCognitoUser = useCallback(
    (personId: number) => {
      return request({
        method: 'get',
        url: `/people/${personId}/cognito-user`,
      })
    },
    [request],
  )

  return [getCognitoUser, status]
}
